<h1>
    @if(fleet) {
    <a href="/status-enrolled?ref=fleet">Fleet</a> -
    } @else if(dlr || international) {
    <a href="/status-enrolled">Dealer</a> -
    } @else if(tempRole == "admin") {
    <a href="/admin-home">Admin</a> -
    }
    Customer Contact Information
</h1>
<section>
    <div class="container">
        <div class="left">
            <h4><u>Account Details:</u></h4>
            <p class="errormsg">{{errormsg}}</p>
            <p class="msg">{{msg}}</p>

            <table>
                <tr>
                    <td>
                        @if(fleet) {
                        <label>FIN Code: *</label>
                        } @else if(dlr || international) {
                        <label>PA Code: *</label>
                        } @else {
                        <label>Username: *</label>
                        }
                    </td>
                    <td>
                        @if(international) {
                        {{uname}}
                        } @else {
                        {{account.username}}
                        }
                    </td>
                </tr>
                <tr>
                    <td>
                        @if(dlr || international) {
                        <label>Dealer Name: *</label>
                        } @else {
                        <label>Company Name: *</label>
                        }
                    </td>
                    <td><input type="text" class="input" autocomplete="off" required id="companyName"
                            [(ngModel)]="account.companyName">
                    </td>
                </tr>
                <tr>
                    <td><label>Contact Name: *</label></td>
                    <td><input type="text" class="input" autocomplete="off" required id="contactName"
                            [(ngModel)]="account.contactName">
                    </td>
                </tr>
                <tr>
                    <td><label>Address: *</label></td>
                    <td><input type="text" class="input" autocomplete="off" required id="address"
                            [(ngModel)]="account.address1"></td>
                </tr>
                <tr>
                    <td><label>Address2: </label></td>
                    <td><input type="text" class="input" autocomplete="off" id="address2"
                            [(ngModel)]="account.address2"></td>
                </tr>
                <tr>
                    <td><label>City: *</label></td>
                    <td><input type="text" class="input" autocomplete="off" required id="city"
                            [(ngModel)]="account.city"></td>
                </tr>
                <tr>
                    <td><label>State/Province: *</label></td>
                    <td>
                        @if(!international) {
                        <select id="filterState" class="select" required [(ngModel)]="selectedState"
                            (ngModelChange)="statesChanged($event)">
                            @for (s of stateList; track s;) {
                            <option [value]="s.stateCode">
                                {{s.stateName}}
                            </option>
                            }
                        </select>
                        }
                        @if(international) {
                        <input type="text" class="input" required autocomplete="off" id="state"
                            [(ngModel)]="account.state">
                        }
                    </td>
                </tr>
                <tr>
                    <td><label>Postal Code: *</label></td>
                    <td><input type="text" class="input" autocomplete="off" required id="zipCode"
                            [(ngModel)]="account.postalCode"></td>
                </tr>
                <tr>
                    <td><label>Country: *</label></td>
                    <td>
                        <select id="filterCountry" required class="select" [(ngModel)]="selectedCountry"
                            (ngModelChange)="countriesChanged($event)">
                            @for (c of countriesList; track c) {
                            <option [value]="c.countryCode">
                                {{c.countryName}}
                            </option>
                            }
                        </select>
                    </td>
                </tr>
                <tr>
                    <td><label>Phone: *</label></td>
                    <td><input type="text" name="phone" autocomplete="off" required class="input" id="phone"
                            [(ngModel)]="account.phone" pattern="^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$"
                            #phoneCtrl="ngModel" [class.is-invalid]="phoneCtrl.invalid && phoneCtrl.touched"
                            [class.is-valid]="phoneCtrl.valid && phoneCtrl.touched" /></td>
                    @if(phoneCtrl.invalid && phoneCtrl.touched) {
                    <div>
                        @if(phoneCtrl.errors?.['required']) {
                        <small>Phone number is required.</small>
                        }
                        @if(phoneCtrl.errors?.['pattern']) {
                        <small>
                            Invalid phone number format.
                        </small>
                        }
                    </div>
                    }
                </tr>
                <tr>
                    <td><label>Email: *</label></td>
                    <td><input type="email" class="input" autocomplete="off" required email #emailCtrl="ngModel"
                            name="email" [(ngModel)]="account.email" /></td>
                    @if(emailCtrl.invalid && emailCtrl.touched) {
                    <div>
                        @if(emailCtrl.errors?.['required']) {
                        <small>Email is required.</small>
                        }
                        @if(emailCtrl.errors?.['email']) {
                        <small>Invalid email format.</small>
                        }
                    </div>
                    }
                </tr>
                <tr>
                    <td><label>Billing Email: *</label></td>
                    <td><input type="email" class="input" autocomplete="off" name="bemail" bemail
                            #billingEmailCtrl="ngModel" [(ngModel)]="account.billingEmail" /></td>

                    @if(billingEmailCtrl.invalid && billingEmailCtrl.touched) {
                    <div>
                        @if(billingEmailCtrl.errors?.['required']) {
                        <small>Billing email is required.</small>
                        }
                        @if(billingEmailCtrl.errors?.['bemail']) {
                        <small>Invalid billing email format.</small>
                        }
                    </div>
                    }
                </tr>
                <tr>
                    <td><label>PO Number: </label></td>
                    <td><input type="text" class="input" id="ponumber" autocomplete="off"
                            [(ngModel)]="account.poNumber"></td>
                </tr>
                @if(admin && !international) {
                <tr>
                    <td><label>Billing Date: </label></td>
                    <td><input type="date" class="input" id="billingDate" autocomplete="off"
                            [(ngModel)]="account.billingDate" /></td>
                </tr>
                <tr>
                    <td><label>Tax Exempt Flag: </label></td>
                    <td>
                        <input type="radio" [value]="true" [(ngModel)]="account.taxExemptFlag"> Yes
                        <input type="radio" [value]="false" [(ngModel)]="account.taxExemptFlag"> No
                    </td>
                </tr>
                }
                <tr>
                    <td colspan="2">* denotes a required field.</td>
                </tr>
                <tr>
                    <td></td>
                    <td style="text-align: right;">
                        <button id="updateButton"
                            [disabled]="!account.companyName || !account.contactName || !account.address1 || !account.city || !selectedCountry || !account.postalCode || !account.phone || emailCtrl.invalid || billingEmailCtrl.invalid"
                            (click)="updateAccount()">Update Account</button>
                    </td>
                </tr>
            </table>
        </div>
        <div class="right">
            @if((admin || fleet) && !international) {
            <app-change-password></app-change-password>
            }

            @if(!dlr && !international && (admin || fleet)) {
            <app-fleet-billing-details></app-fleet-billing-details>
            }
        </div>
    </div>
</section>
@if(!international) {
<app-file-upload></app-file-upload>
}